import React from "react";
import "./TopBar.css";

export default function TopBar() {
  return (
    <div className="top-bar">
      {/* Left Side - Logo & Menu */}
      <div className="left-section">
        <img
          src="/logo512.png"
          alt="Logo"
          className="logo"
        />

        <div className="menu-icon">☰</div>
      </div>

      {/* Center Tabs */}
      <div className="center-tabs">
        <button className="tab active">Exchange</button>
        <button className="tab">Wallet</button>
      </div>

      {/* Right Side Icons */}
      <div className="right-section">
        <div className="icon">🎁</div>
        <div className="icon">⬇️</div>
        <div className="user-avatar">👤</div>
      </div>
    </div>
  );
}